



























































































































import { Vue, Component, Watch } from "vue-property-decorator";
import courseListeners, {
  CourseListenersListParams
} from "@/getinfo-api/course-listeners";
import SelectEntity from "@/components/form/SelectEntity.vue";
import { CourseListener as ICourseListener } from "@/api/models/course-listener";
import { CourseListenersList as ICourseListenersList } from "@/api/models/course-listeners-list";
import ListenerProgressPreviewItem from "@/components/learning-progress/ListenerProgressPreviewItem.vue";
import { uniqBy } from "lodash";
import CustomTable from "@/components/form/CustomTable.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import CPage from "@/components/form/CustomPage/CPage.vue";
import CField from "@/components/form/CField.vue";
import CSingleSelect from "@/components/form/CSingleSelect.vue";
import { CoursesListClass } from "@/classes/list/CoursesListClass";
import CourseRegistrations, {
  CourseRegistrationsListParams
} from "@/getinfo-api/courseRegistrations";
import { Course as ICourse } from "@/api-v2/course/models/course";
import { Registration as IRegistration } from "@/api-v2/course/models/registration";
import RegistrationsProgressItem from "@/components/learning-progress/RegistrationsProgressItem.vue";

@Component({
  components: {
    RegistrationsProgressItem,
    CSingleSelect,
    CField,
    CPage,
    CustomButton,
    CustomTable,
    SelectEntity,
    ListenerProgressPreviewItem
  }
})
export default class LearningProgressList extends Vue {
  showSpinner: boolean = false;
  showNoResult: boolean = false;
  selectedCourse!: ICourse;
  listenersOffset: number = 0;
  listenersCount: number = 0;
  listenersLimit: number = 30;
  listeners: Array<ICourseListener> = [];
  success: boolean | undefined;
  passed: boolean | undefined;
  coursesList: CoursesListClass = new CoursesListClass({ mode: "v2" });
  registrations: Array<IRegistration> = [];
  registrationsCount: number = 0;
  studentName: string = "";

  data() {
    return {
      selectedCourse: undefined,
      success: undefined,
      passed: undefined
    };
  }

  applyFilter() {
    this.listeners = [];
    this.listenersOffset = 0;
    this.registrations = [];
    this.registrationsCount = 0;
    this.showNoResult = false;
    this.getListeners();
  }

  clearForm() {
    this.listeners = [];
    this.passed = undefined;
    this.success = undefined;
    //@ts-ignore
    this.selectedCourse = undefined;
    this.showNoResult = false;
    this.registrations = [];
    this.registrationsCount = 0;
    this.studentName = "";
  }

  showMore() {
    this.listenersOffset += this.listenersLimit;
    this.getListeners(this.listenersOffset);
  }

  getV1CourseListeners(offset: number = 0) {
    this.showSpinner = true;
    this.showNoResult = false;
    let params: CourseListenersListParams = {
      id: this.selectedCourse?.id,
      success: this.success !== undefined ? this.success : undefined,
      passed: this.passed !== undefined ? this.passed : undefined,
      offset: offset,
      limit: this.listenersLimit
    };
    courseListeners(params)
      .then((res: { data: ICourseListenersList }) => {
        this.listenersCount = res.data.count;
        if (res.data.listeners.length === 0) this.showNoResult = true;
        res.data.listeners?.forEach(el => {
          this.listeners.push(el);
        });
        this.listeners.sort(
          (a, b) =>
            new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
        );
        this.listeners = uniqBy(this.listeners, "id");
      })
      .finally(() => {
        this.showSpinner = false;
      });
  }

  async getCourseRegistration(offset: number) {
    this.showSpinner = true;
    const params: CourseRegistrationsListParams = {
      courseIds: [this.selectedCourse?.id],
      studentName: this.studentName ?? undefined,
      sort: "finishedAt",
      order: "DESC",
      limit: 30,
      offset: offset
    };
    try {
      const { data } = await CourseRegistrations(params);
      this.registrations = [...this.registrations, ...data.items];
      this.registrationsCount = data.count;
    } finally {
      this.showSpinner = false;
    }
  }

  async getListeners(offset: number = 0) {
    if (await this.$store.dispatch("validate/CHECK_VALIDATIONS")) return;
    if (this.selectedCourse) {
      //@ts-ignore
      if (this.selectedCourse.version === "v1") {
        this.getV1CourseListeners(offset);
      } else {
        await this.getCourseRegistration(offset);
      }
    }
  }

  @Watch("passed")
  updateStatusSelect() {
    if (this.passed === false || this.passed === undefined) {
      this.success = undefined;
    }
  }
}
